import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons/js/free'

interface ErrorScreenProps {
  errorMessage?: string // Основной текст ошибки
  title?: string // Заголовок (по умолчанию "Ошибка")
  showRetry?: boolean // Показывать кнопку "Попробовать снова"?
  onRetry?: () => void // Коллбэк для кнопки повтора
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  errorMessage = 'При выполнении запроса произошла ошибка',
  title = 'Ошибка',
  showRetry = false,
  onRetry,
}) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ height: '70vh' }}
    >
      <div className="text-center">
        <div className="mb-2 text-danger">
          <CIcon icon={cilWarning} size="5xl" />
        </div>
        <h1 className="display-5 fw-bold">{title}</h1>
        <p className="fs-4 mb-4">{errorMessage}</p>
        {showRetry && (
          <button className="btn btn-primary mt-3" onClick={onRetry}>
            Попробовать снова
          </button>
        )}
      </div>
    </div>
  )
}
